export enum UserRole {
  ADMIN = 1,
  USER = 2,
  STAFF = 3
}
